module.exports = __webpack_public_path__ + "static/media/Forestbrook_Bylaws.4b795467.pdf";